export default "__VITE_ASSET__DKT4xb8___"